import { render, staticRenderFns } from "./v-popup.vue?vue&type=template&id=78d3f1e8&scoped=true&"
import script from "./v-popup.vue?vue&type=script&lang=js&"
export * from "./v-popup.vue?vue&type=script&lang=js&"
import style0 from "./v-popup.vue?vue&type=style&index=0&id=78d3f1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d3f1e8",
  null
  
)

export default component.exports